/*!
 * @author electricessence / https://github.com/electricessence/
 * Based upon .NET source.
 * Licensing: MIT https://github.com/electricessence/TypeScript.NET/blob/master/LICENSE.md
 * Source: http://referencesource.microsoft.com/#mscorlib/system/IObserver.cs
 */
define(["require", "exports", "./ObservableBase", "../../extends"], function (require, exports, ObservableBase_1, extends_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // noinspection JSUnusedLocalSymbols
    var __extends = extends_1.default;
    var ObservableNodeBase = /** @class */ (function (_super) {
        __extends(ObservableNodeBase, _super);
        function ObservableNodeBase() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ObservableNodeBase.prototype.onNext = function (value) {
            this._onNext(value);
        };
        ObservableNodeBase.prototype.onError = function (error) {
            this._onError(error);
        };
        ObservableNodeBase.prototype.onCompleted = function () {
            this._onCompleted();
        };
        return ObservableNodeBase;
    }(ObservableBase_1.default));
    exports.ObservableNodeBase = ObservableNodeBase;
    exports.default = ObservableNodeBase;
});
